var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.configurationOk == 0
    ? _c(
        "v-app",
        [
          _c(
            "v-container",
            { staticStyle: { height: "400px" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "fill-height",
                  attrs: { "align-content": "center", justify: "center" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-subtitle-1 text-center",
                      attrs: { cols: "12" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.loading_Config")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-progress-linear", {
                        attrs: {
                          color: "primary",
                          indeterminate: "",
                          rounded: "",
                          height: "6",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm.configurationOk == 1
    ? _c(
        "v-app",
        [
          _c("v-main", [_c("router-view", { staticClass: "fill-height" })], 1),
          _c("Snackbar", { ref: "snackbar" }),
        ],
        1
      )
    : _vm.configurationOk == 2
    ? _c(
        "v-app",
        [
          _c(
            "v-container",
            { staticStyle: { height: "400px" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "fill-height",
                  attrs: { "align-content": "center", justify: "center" },
                },
                [
                  _c("v-icon", { attrs: { color: "red", "x-large": "" } }, [
                    _vm._v("mdi-lock-alert-outline"),
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-subtitle-1 text-center",
                      attrs: { cols: "12" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("errors.noHaKuBuForThisClub")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }